/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

const INIT_STATE = {
    selectedCard: {},
    selectedMapFeature: {},
    shouldSearchOnMove: false,
    visibleMapItemIds: null,
};

export default function searchMapSyncReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case types.SEARCH_HANDLE_SELECTED_CARD:
            return { ...state, selectedCard: action.payload };

        case types.SEARCH_HANDLE_SELECTED_MAP_FEATURE:
            return { ...state, selectedMapFeature: action.payload };

        case types.SEARCH_HANDLE_SEARCH_ON_MOVE:
            return { ...state, shouldSearchOnMove: action.payload };

        case types.SET_VISIBLE_MAP_ITEMS:
            return { ...state, visibleMapItemIds: action.payload };

        default:
            return state;
    }
}
